import "./blog.css";
import ConvertDate from "./ConvertData";

const Blog = ({ blog }) => {
  // Determine blog type class
  const getBlogTypeClass = () => {
    if (blog.is_interview_schedule) return "blog-interview-schedule";
    if (blog.is_interview_shortlist) return "blog-interview-shortlist";
    if (blog.is_final_selections) return "blog-final-selections";
    return "";
  };

  // Get badge for blog type
  const getBlogTypeBadge = () => {
    if (blog.is_interview_schedule) {
      return (
        <span className="blog-type-badge badge-interview-schedule">
          <i className="fas fa-calendar-alt"></i> Interview Schedule
        </span>
      );
    }
    if (blog.is_interview_shortlist) {
      return (
        <span className="blog-type-badge badge-interview-shortlist">
          <i className="fas fa-clipboard-list"></i> Interview Shortlist
        </span>
      );
    }
    if (blog.is_final_selections) {
      return (
        <span className="blog-type-badge badge-final-selections">
          <i className="fas fa-trophy"></i> Final Selections
        </span>
      );
    }
    return null;
  };

  const getTitle = () => {
    if (
      blog.is_interview_schedule ||
      blog.is_interview_shortlist ||
      blog.is_final_selections
    ) {
      return `${blog.interview_project.company_name_designation} | Project ID: ${blog.interview_project.id}`;
    }
    return blog.title;
  };

  return (
    <div className={`blog ${getBlogTypeClass()}`}>
      {/* Header Section */}
      <div className="blog-header">
        {getBlogTypeBadge()}
        <h5 className="interview-schedule-title">{getTitle()}</h5>
      </div>

      {/* Meta Information */}
      <div className="blog-meta">
        <div className="meta-date">
          <ConvertDate dateString={blog.current_date_time} />
        </div>

        <div className="meta-details">
          {blog.is_interview_schedule && blog.interview_mode && (
            <div className="meta-item">
              <i className="fas fa-video"></i>
              <span>Mode: {blog.interview_mode}</span>
            </div>
          )}

          {(blog.is_interview_schedule || blog.is_interview_shortlist) &&
            blog.interview_date && (
              <div className="meta-item">
                <i className="fas fa-calendar-check"></i>
                <span>Interview: {blog.interview_date}</span>
              </div>
            )}
        </div>
      </div>

      {/* Students Section */}
      {(blog.is_interview_schedule ||
        blog.is_interview_shortlist ||
        blog.is_final_selections) &&
        blog.interview_schedule_or_shortlisted_students_or_final_students &&
        blog.interview_schedule_or_shortlisted_students_or_final_students
          .length > 0 && (
          <div className="blog-students-section">
            <div className="students-grid">
              {/* Name Column */}
              <div className="student-column">
                <h6>
                  <i className="fas fa-user"></i> Name
                </h6>
                {blog.interview_schedule_or_shortlisted_students_or_final_students.map(
                  (student, index) => (
                    <p key={`name-${index}`}>{student.fullname}</p>
                  )
                )}
              </div>

              {/* Roll No Column */}
              <div className="student-column">
                <h6>
                  <i className="fas fa-id-card"></i> Roll Number
                </h6>
                {blog.interview_schedule_or_shortlisted_students_or_final_students.map(
                  (student, index) => (
                    <p key={`roll-${index}`}>{student.ldap.split("@")[0]}</p>
                  )
                )}
              </div>

              {/* Time Column (only for interview schedule) */}
              {blog.is_interview_schedule && blog.interview_times && (
                <div className="student-column">
                  <h6>
                    <i className="fas fa-clock"></i> Interview Time
                  </h6>
                  {blog.interview_times.split(",").map((time, index) => (
                    <p key={`time-${index}`}>{time.trim()}</p>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

      {/* Content Section */}
      {blog.content && (
        <div className="blog-content">
          <p>{blog.content}</p>
        </div>
      )}
    </div>
  );
};

export default Blog;
